<template>
    <div ref="ttip" :style="style" class="ttip">
        <div class="arrow"></div>
        <div class="inner">
            <h2 v-if="title">{{title}}</h2>
            <p v-if="info">{{info}}</p>
            <p><span class="badge" v-for="(tag, idx) in tags" :key="idx">{{ tag }}</span></p>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    offset: {
      type: Object,
      reqired: true,
    },
    tags: {
      type: Array,
      default() { return []; },
    },
  },
  computed: {
    style() {
      return { left: `${this.ttip.x}px`, top: `${this.ttip.y}px` };
    },
  },
  mounted() {
    window.addEventListener('mousemove', (e) => {
      this.ttip.x = e.clientX + this.offset.x + document.querySelector('.offcanvas').scrollLeft;
      this.ttip.y = e.clientY + this.offset.y + document.querySelector('.offcanvas').scrollTop;
    });
  },
  methods: {

  },
  data() {
    return {
      ttip: {
        x: null,
        y: null,
        title: null,
        info: null,
      },
    };
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.ttip{
    position:absolute;
    display:block;
    left: -9999px;
    z-index: 100;

     .arrow{
            position:absolute;
            width: 0;
            height: 0;
            top: 20px;
            border-style: solid;
            border-width: 5px 5px 5px 0;
            border-color: transparent $tooltipback transparent transparent;
            z-index:100;
        }

    .inner{
        position: absolute;
        color: $tooltipfront;
        z-index: 100;
        background-color: $tooltipback;
        padding:1rem;
        margin-left:5px;
        min-width:175px;

        h2 {
            font-size: 1rem;
            padding:0;
            margin: 0 0 0.5rem 0;
            white-space: nowrap;
        }

        p{
            font-size:0.8rem;
            line-height: 0.9rem;
            padding:0;
            margin:0 0 5px 0;
        }

        .badge{
          display: inline-block;
          font-family: 'SourceCodePro Bold';
          font-size:0.55rem;
          line-height:0.55rem;
          border: 1px solid $carbon;
          color: $tooltipfront;
          background-color: $sky;
          border-radius: 3px;
          margin: 2px;
          padding:2px 2px;
          text-transform: uppercase;
        }
    }
  }
</style>
